import { useTheme } from "@emotion/react";
import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { NumericFormat } from "react-number-format";
import SaudiRiyalSymbol from "../Currency/SaudiRiyalSymbol";

const NumericIconCard = ({ title, value, imageSrc }) => {
  const theme = useTheme();

  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        height: "96px",
        width: "100%",
        maxWidth: "300px",
        minWidth: { xs: "200px", sm: "250px" },
        backgroundColor: "background.paper",
        border: `1px solid ${theme.palette.gray.g60}`,
        borderRadius: "20px",
        padding: "1rem",
        flexShrink: 1,
      }}
    >
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        height={"64px"}
      >
        <Typography variant="body2" color="gray.g600">
          {title}
        </Typography>
        <NumericFormat
          value={value}
          thousandSeparator=","
          displayType="text"
          type="text"
          renderText={(formattedValue) => (
            <Typography variant="h5" fontWeight={600}>
              <Typography
                variant="h6"
                component="span"
                color="gray.g600"
                dir="ltr"
              >
                {formattedValue}
              </Typography>
              <SaudiRiyalSymbol width={16} height={16} color="#475467" />
            </Typography>
          )}
        />
      </Stack>
      <Stack sx={{ width: "64px", height: "64px" }}>
        <img src={imageSrc} alt="Icon" />
      </Stack>
    </Stack>
  );
};

export default NumericIconCard;